import React from 'react';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import type { PartnerIndianMarketCharges } from '../../../models/PartnerPortalTypes';
import { formatCurrency } from '../../../utils/CurrencyFormat';

function chargeTotal(c: PartnerIndianMarketCharges): number {
  return (
    c.stt +
    c.brokerage +
    c.gstOnBrokerage +
    c.exchangeTxnCharges +
    c.sebiTurnoverFees +
    c.stampDuty
  );
}

interface Props {
  charges: PartnerIndianMarketCharges;
}

const PartnerChargesTable: React.FC<Props> = ({ charges }) => {
  const rows: [string, number][] = [
    ['STT', charges.stt],
    ['Brokerage', charges.brokerage],
    ['GST on brokerage', charges.gstOnBrokerage],
    ['Exchange txn charges', charges.exchangeTxnCharges],
    ['SEBI turnover fees', charges.sebiTurnoverFees],
    ['Stamp duty', charges.stampDuty],
  ];
  return (
    <Table size="small" sx={{ '& td': { py: 0.25, border: 0 } }}>
      <TableBody>
        {rows.map(([label, amt]) =>
          amt > 0 ? (
            <TableRow key={label}>
              <TableCell sx={{ color: 'text.secondary', pl: 0 }}>{label}</TableCell>
              <TableCell align="right">{formatCurrency(amt)}</TableCell>
            </TableRow>
          ) : null
        )}
        <TableRow>
          <TableCell sx={{ fontWeight: 600, pl: 0 }}>Total charges</TableCell>
          <TableCell align="right" sx={{ fontWeight: 600 }}>
            {formatCurrency(chargeTotal(charges))}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default PartnerChargesTable;
